import React from "react";

export function Prepend(props) {
    return (
        <div className="input-group-prepend">
            <span className="input-group-text"><small>{props.value}</small></span>
        </div>
    )
}

